"use strict";

require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.error.cause.js");
require("core-js/modules/es.array.filter.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
require("core-js/modules/es.object.get-own-property-descriptors.js");
require("core-js/modules/es.object.keys.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/web.dom-collections.iterator.js");
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.promise.js");
var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));
var _pickBy2 = _interopRequireDefault(require("lodash/pickBy"));
var _apiHelpers = require("./apiHelpers");
var _storage = require("../util/storage");
var _logRocketCookieUtils = require("../util/logrocket/logRocketCookieUtils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Method = {
  get: 'GET',
  post: 'POST',
  put: 'PUT',
  patch: 'PATCH',
  delete: 'DELETE'
};
var CSRF_TOKEN_HEADER = 'x-csrf-token';
var CSRF_TOKEN_COOKIE = 'CSRF-TOKEN';
var LOG_ROCKET_HEADER = 'x-record-request-body';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var request = function request(url, options) {
  var requestChainFn = function requestChainFn() {
    return (0, _isomorphicFetch.default)(url, options).then(_apiHelpers.handlePromise).then(_apiHelpers.handleErrors);
  };
  var requestPromise = new Promise(function (resolve, reject) {
    requestChainFn().then(resolve).catch(function (e) {
      try {
        (0, _apiHelpers.handleTwoFactor)(e, function () {
          return resolve(requestChainFn());
        });
      } catch (e2) {
        reject(e2);
      }
    });
  });
  return requestPromise;
};
var get = function get(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var finalHeaders = _objectSpread(_objectSpread({
    'Content-Type': _apiHelpers.CONTENT_TYPE_JSON
  }, (0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE) ? _defineProperty({}, LOG_ROCKET_HEADER, 'true') : {}), headers);
  var finalOptions = _objectSpread({
    method: Method.get,
    credentials: 'same-origin',
    headers: finalHeaders
  }, options);
  return request(url, finalOptions);
};
var post = function post(url, body) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var combinedHeaders = _objectSpread(_objectSpread(_defineProperty({
    'Content-Type': body instanceof FormData ? _apiHelpers.CONTENT_TYPE_MULTIPART_FORM : _apiHelpers.CONTENT_TYPE_JSON
  }, CSRF_TOKEN_HEADER, (0, _storage.getCookie)(CSRF_TOKEN_COOKIE)), (0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE) ? _defineProperty({}, LOG_ROCKET_HEADER, 'true') : {}), headers);
  var finalHeaders = (0, _pickBy2.default)(combinedHeaders, function (value) {
    return value !== undefined;
  });
  var finalBody = finalHeaders['Content-Type'] === _apiHelpers.CONTENT_TYPE_JSON ? JSON.stringify(body) : body;
  var finalOptions = _objectSpread({
    method: Method.post,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders
  }, options);
  return request(url, finalOptions);
};
var put = function put(url, body) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var finalHeaders = _objectSpread(_objectSpread(_defineProperty({
    'Content-Type': _apiHelpers.CONTENT_TYPE_JSON
  }, CSRF_TOKEN_HEADER, (0, _storage.getCookie)(CSRF_TOKEN_COOKIE)), (0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE) ? _defineProperty({}, LOG_ROCKET_HEADER, 'true') : {}), headers);
  var finalBody = JSON.stringify(body);
  var finalOptions = _objectSpread({
    method: Method.put,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders
  }, options);
  return request(url, finalOptions);
};
var patch = function patch(url, body) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var finalHeaders = _objectSpread(_objectSpread(_defineProperty({
    'Content-Type': _apiHelpers.CONTENT_TYPE_JSON
  }, CSRF_TOKEN_HEADER, (0, _storage.getCookie)(CSRF_TOKEN_COOKIE)), (0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE) ? _defineProperty({}, LOG_ROCKET_HEADER, 'true') : {}), headers);
  var finalBody = JSON.stringify(body);
  var finalOptions = _objectSpread({
    method: Method.patch,
    credentials: 'same-origin',
    body: finalBody,
    headers: finalHeaders
  }, options);
  return request(url, finalOptions);
};
var deleteMethod = function deleteMethod(url) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var finalHeaders = _objectSpread(_objectSpread(_defineProperty({
    'Content-Type': _apiHelpers.CONTENT_TYPE_JSON
  }, CSRF_TOKEN_HEADER, (0, _storage.getCookie)(CSRF_TOKEN_COOKIE)), (0, _storage.getCookie)(_logRocketCookieUtils.LOG_ROCKET_COOKIE) ? _defineProperty({}, LOG_ROCKET_HEADER, 'true') : {}), headers);
  var finalOptions = _objectSpread({
    method: Method.delete,
    credentials: 'same-origin',
    headers: finalHeaders
  }, options);
  return request(url, finalOptions);
};
var _default = exports.default = {
  request: request,
  get: get,
  post: post,
  put: put,
  patch: patch,
  delete: deleteMethod
};